export function normalize(name: string) {
    return name; //todo implement
}



// WEBPACK FOOTER //
// ./src/tools/normalize.ts